<div class="space-y-5">
  <app-breadcrumbs [items]="breadcrumbs()" />

  @if (!selectedReportType()) {
    <section class="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm sm:p-5">
      <h1 class="text-xl font-semibold text-slate-900">Reports List</h1>
      <p class="mt-1 text-sm text-slate-500">
        Choose a report type to open its dedicated filters, results table, and CSV export.
      </p>

      <div class="mt-5 grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        @for (report of reportCatalog; track report.type) {
          <a
            class="report-card rounded-2xl border border-slate-200 bg-white p-4 text-left shadow-sm"
            [routerLink]="['/reports', report.slug]"
          >
            <h2 class="text-base font-semibold text-slate-900">{{ report.title }}</h2>
            <p class="mt-2 text-sm text-slate-600">{{ report.description }}</p>
            <span class="mt-4 inline-block text-sm font-medium text-slate-900">Open Report</span>
          </a>
        }
      </div>
    </section>
  } @else {
    @if (selectedReport(); as selected) {
      <section class="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm sm:p-5">
        <div class="flex flex-wrap items-start justify-between gap-3">
          <div>
            <h1 class="text-xl font-semibold text-slate-900">{{ selected.title }}</h1>
            <p class="mt-1 text-sm text-slate-500">{{ selected.description }}</p>
          </div>

          <a
            class="rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
            [routerLink]="['/reports']"
          >
            Back to Reports List
          </a>
        </div>
      </section>
    }

    @if (selectedReportType() === 'program-summary') {
      <app-program-summary-report />
    }

    @if (selectedReportType() === 'client-demographics') {
      <app-client-demographics-report />
    }

    @if (selectedReportType() === 'outreach-contacts') {
      <app-outreach-contacts-report />
    }

    @if (selectedReportType() === 'services-provided') {
      <app-services-provided-report />
    }

    @if (selectedReportType() === 'mediation') {
      <app-mediation-report />
    }

    @if (selectedReportType() === 'outcomes') {
      <app-outcomes-report />
    }

    @if (selectedReportType() === 'geographic-distribution') {
      <app-geographic-distribution-report />
    }
  }
</div>
